import { extraPrices } from '../constants/common';

const getMaxDomainDiscount = (currency, prices, extraPrice) => {
  const discounts = Object.values(prices).map((tld) => {
    const priceData = tld.P1Y;
    let oldPrice = 0;
    let price = 0;

    if (extraPrice === extraPrices.ANNUAL_TRIAL_PACKAGE) {
      oldPrice = priceData.prices[currency] || 0;
      price = priceData.extra_prices?.[extraPrice]?.[currency] || 0;
    }

    if (extraPrice === extraPrices.NO_DISCOUNTS) {
      oldPrice = priceData.extra_prices?.[extraPrice]?.[currency] || 0;
      price = priceData.prices[currency] || 0;
    }

    return price ? oldPrice - price : 0;
  });

  return Math.max(...discounts, 0);
};

export default getMaxDomainDiscount;
